import { Component, OnInit, ViewChild } from '@angular/core';
import { EditorModule } from 'primeng/editor';
import { FileUpload } from 'primeng/fileupload';

import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Message } from 'primeng/api/message';
import { NgForm } from '@angular/forms';
import { ValidateformComponent } from '../../common/validateform/validateform.component';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { ConfirmationService } from 'primeng/api';
import { NewsService } from 'src/app/services/NewsService';
import { AlertService } from 'src/app/services/AlertService';


@Component({
  selector: 'app-news-add',
  templateUrl: './news-add.component.html',
  styleUrls: ['./news-add.component.scss']
})
export class NewsAddComponent implements OnInit {
    @ViewChild(FileUpload) pFileUpload: FileUpload;
    @ViewChild('f', { static: true }) addNewsForm: NgForm;
    @ViewChild(ValidateformComponent, { static: true })
    private formValidator: ValidateformComponent;

    options: any
    news: any;
    newsTypeOptions: any[] = [];
    messageId: any;
    uploadURL: string = environment.apiBase.concat("News/UploadMessageDocuments");
    msgs: Message[];

    constructor(private newsService: NewsService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private breadcrumbService: AppBreadcrumbService,
                private confirmationService: ConfirmationService,
                private alertService: AlertService) { }

    ngOnInit(): void {
        this.breadcrumbService.setItems([
            this.breadcrumbService.news,
            this.breadcrumbService.newsAdd,
        ]);

        this.initNews();
        this.options = this.activatedRoute.snapshot.data['options'];
        this.parseOptions();
    }

    parseOptions() {
        this.newsTypeOptions = new Array();
        for (let o of this.options[0]) {
            let l = o.Description;
            this.newsTypeOptions.push({ label: l, value: o.Id });
        }
    }

    initNews() {
        this.news = {};
        this.news.HeadLine = '';
        this.news.BroadcastBody = '';
        this.news.NewsMessageTypeID = null;
        this.news.Active = true;
        this.news.Archived = false;
        this.news.MessageSourceTypeID = 2;
        this.news.Documents = [];
    }

    saveNews() {
        if (this.formValidator.validateForm()) {
            this.newsService.addNews(this.news).subscribe(
                result => {
                    this.messageId = result.Id;
                    if (this.pFileUpload.files.length > 0) {
                        this.pFileUpload.upload();
                    }
                    else {
                        this.router.navigate(['']);
                    }
                },
                error => {
                    this.alertService.SetMessage('error', 'There is an error while adding news');
                }
            );
        }        
    }

    onBeforeUpload(event) {
        if (this.messageId != undefined && this.messageId != 0) {
            event.formData.append('MessageId', this.messageId);
            event.formData.append('Description', 'Message Document');
        }
        else {
            event.xhr.abort();
            event.xhr = null;
            event.stopPropogation();
            this.alertService.SetMessage('error', 'There is an error while uploading file');
        }
    }

    onUploadCompleted(event) {
        if (event.originalEvent.ok) {
              this.router.navigate(['']);
        }
        else {            
            this.alertService.SetMessage('error', 'There is an error while uploading file');
        }     
    }

    cancelAddNews() {
        this.confirmationService.confirm({
            key: "AddNewsConfirmDialog",
            message: 'Are you sure that you want to Cancel? You will lose all changes made.',
            accept: () => {
                this.router.navigate(['/']);
            }
        });
    }
}
